export default __webpack_public_path__ + "static/media/IMG_9952.dee3753c.webp";